export default "__VITE_ASSET__C0MlMt5i__"